import PriorityItem from './PriorityItem.container';

export default PriorityItem;
